import { BACKGROUNDS } from '@/utils/constants';

/**
 * the state which holds the current context for the UI
 */
export default {
    namespaced: true,

    state: {
        background: BACKGROUNDS.MIDNIGHT_BLUE,
        scrolling: false,
        route: {},
    },

    getters: {
        bgColor: state => state.background,
        isScrolling: state => state.scrolling,
        route: state => state.route,
    },

    actions: {
        setBgColor ({commit}, color ) {
            commit('setBgColor', color);
        },
        setScrolling ({ commit }, value) {
            commit('setScrolling', value);
        },
        setRoute ({commit}, data) {
            commit('setRoute', data);
        },
    },

    mutations: {
        setBgColor (state, color) {
            state.background = color;
        },
        setScrolling (state, value) {
            state.scrolling = value;
        },
        setRoute (state, data) {
            state.route = data;
        },
    },
};
